// extracted by mini-css-extract-plugin
export default {"fixedHeightColumn":"R4pEqB","center":"C_mN9e","top":"E6Dg1P"};